(function() {
    'use strict';

    angular
        .module('payees')
        .controller('PayeesController', PayeesController);

    /* @ngInject */
    function PayeesController($scope, $state, $uibModal, toastr, PayeesService, Payee) {
        var vm = this;

        // /* Bindable methods */
        vm.create = create;
        vm.edit = edit;
        vm.remove = remove;
        
        /* View rendering */
        /*
        var view = {
            renderers: { 
                'root.payees.list': list 
            },
            init: () => view.renderers[$state.current.name](),
            refresh: () => {$state.go($state.current, $state.params, { reload: true })},
        };
        */
        // Initializing view
        //view.init();

        /* Imeplentations by Marcus */
        vm.queryFlag    = false;
        vm.name         = '';
        vm.getByFilter  = getByFilter;
        vm.activate     = activate;

        /* Pagination */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function activate()
        {
            vm.getByFilter();
        }

        activate();

        function getByFilter()
        {
            vm.queryFlag = false;
            vm.query = {};
            vm.query['page']    = vm.page;
            if(vm.name !== '') {
                vm.query['name'] = vm.name;
            }
            PayeesService.getByFilter(vm.query).then(function(response){
                vm.queryFlag        = true;
                vm.payees           = response.data.data;
                vm.totalItems       = response.data.total;
                vm.itemsPerPage     = response.data.per_page;
                vm.setPage(response.data.current_page);

                if (!vm.payees || !vm.payees.length) {
                    vm.resultMessage = 'Sorry, no results were found!';
                }
            });
        }
        
        /* Implementation details */
        function create() {
            form();
        }
        
        function edit(payee) {
            var payee = new Payee(payee);
            form(payee);
        }

        function list() {
            /* Model Collection */
            vm.payees = PayeesService.payees;

            /* Pagination */
            vm.pagination = {
                pageChanged: pageChanged,
                currentPage: PayeesService.currentPage,
                totalItems: PayeesService.totalItems,
                to: PayeesService.to,
                itemsPerPage: PayeesService.itemsPerPage,
            }
            
            /* No results */
            if (!vm.payees || !vm.payees.length) {   
                vm.resultMessage = 'Sorry, no results were found!';
            }
    
            /* Implementation details */
            function pageChanged () {
                $state.params.filters = $state.params.filters || {};
                $state.params.filters['page'] = vm.pagination.currentPage || 1;
                view.refresh();
            }
        }

        function remove(id) {
            alertify
                .confirm('Do you really want to delete this cost center?<br>This action is irreversible!')
                .set('labels', {
                    ok: 'Yes, delete this cost center',
                    cancel: 'No'
                })
                .set('title', 'Delete Payee')
                .set('onok', function () {
                    PayeesService.deletePayee(id)
                    .then(() => toastr.success('Cost center successfully deleted'))
                    .catch(() => toastr.error('Something went wrong. Please try again later'))
                    .finally(() => view.refresh());
                })
                .show();
        }

        function form(payee) {
            var payees;
            
            $uibModal.open({
                templateUrl: 'templates/payees/templates/payees-form.html',
                controller: ['$uibModalInstance', function ($uibModalInstance) {
                    var modal = this;
                    
                    /* Payee Model */
                    modal.payee = payee || new Payee();
                    
                    /* Bindable methods */
                    modal.cancel = $uibModalInstance.close;
                    modal.save = save;

                    /* Form */
                    modal.payees = payees;
                    modal.form_error = false;
                    
                    function save() {
                        modal.form_error = true;
                        if(!modal.payee.name) {
                            return;
                        }
                        modal.form_error = false;

                        var method;

                        if (modal.payee.id) {
                            method = 'updatePayee'
                        }
                        else {
                            method = 'createPayee';
                        }

                        PayeesService[method](modal.payee)
                            .then(() => {
                                toastr.success('Payee successfully saved');
                                modal.cancel();
                                view.refresh();
                            })
                            .catch(res => {
                                switch (res.data.message) {
                                    case 'SQLSTATE[23000]' || 'validator':
                                        toastr.error('Name already taken, please choose another one');
                                        break;
                                    default:
                                        toastr.error('Something went wrong. Please try again later');
                                        break;
                                }
                            });
                    }
                }],
                controllerAs: 'modal',
            })
        }
    }
})();